import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: object;
  noindex?: boolean;
  canonical?: string;
}

const SEO = ({
  title = 'Book My Yoga TTC - Find Your Perfect Yoga Teacher Training',
  description = 'Discover authentic yoga teacher training programs worldwide. Get expert consultation to find the perfect school for your yoga journey. Certified programs in Rishikesh, India and beyond.',
  keywords = 'yoga teacher training, yoga certification, 200 hour ytt, 300 hour ytt, rishikesh yoga, yoga school, yoga alliance certified, yoga teacher training india',
  image = '/images/cover.png',
  url = 'https://bookmyyogattc.com',
  type = 'website',
  structuredData,
  noindex = false,
  canonical,
}: SEOProps) => {
  const fullTitle = title.includes('Book My Yoga TTC') ? title : `${title} | Book My Yoga TTC`;
  const fullUrl = canonical || url;
  const fullImage = image.startsWith('http') ? image : `${url}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Book My Yoga TTC" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />

      {/* Additional Meta Tags */}
      <meta name="author" content="Book My Yoga TTC" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;


